import styled from "styled-components";

export const ModalTitle = styled.h2`
  color: var(--color-neutral-600);
  font-weight: var(--font-weight-semibold);
  font-size: 18px;
  line-height: 20px;
  margin: 0 0 .8rem 0;
`

export const ModalContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
  margin-bottom: 2rem;
  font-size: 16px;
`

export const ModalText = styled.p`
  margin: 18px 0px;
`

export const ModalActions = styled.div`
  display: flex;
  gap: .5rem;
`